Vue.component('seasonalleaderboard', {
    template: templates.seasonalLeaderBoard,
    data() {
      return {
        model: {
          users: [],
          top: [],
          medals: [],
          isLoggedIn: false,
          teamLoaded: false,
          tab: null,
          single: [],
          teams: [],
          topTeams: [],
          seasons: [],
          selectedSeason: null,
          selectedOption: 0,
          memberCount: 4,
          options: [
            { value: 'Squad', name: 'Squad' },
            { value: '2v2', name: '2v2' },
            { value: '3v3', name: '3v3' },
            { value: '4v4', name: '4v4' }
          ],
        }
      }
    },
    mounted() {
      const c = this;
      c.getSeasons();
 
 

    },
    methods: {
      showTab(tab){
        const c = this;
        c.model.tab = tab;

        // if(tab === 'team'){
        //   c.getTeam();
        // }
      },
      async get() {
        const c = this;
  
        try {
            const response = await userService.getSeasonSingle();

            c.model.single = response.data;
            c.model.tab = 'single';
            c.model.isLoggedIn = true;
            // const fetchUserData = (team, index) => {
            //     return new Promise((resolve) => {
            //         c.getCurrentTwitchInfo(c.model.single[index].user[0].twitchId, function(user) {
            //             if (user) {
            //                 // Update the user object with the new Twitch data
            //                 team[index].user[0] = {
            //                     twitchId: user.twitchId,
            //                     twitchDisplayName: user.twitchDisplayName,
            //                     twitchProfileImage: user.twitchProfileImage
            //                 };
            //             } else {
            //                 // If no user data is found, retain the existing user properties
            //                 team[index].user[0] = {
            //                     twitchId: team[index].user[0].twitchId,
            //                     twitchDisplayName: team[index].user[0].twitchDisplayName,
            //                     twitchProfileImage: team[index].user[0].twitchProfileImage
            //                 };
            //             }
            //             resolve();
            //         });
            //     });
            // };
  
            // const userPromises = c.model.single.map((user, index) => fetchUserData(c.model.single, index));
            // await Promise.all(userPromises);
  
            const first = c.model.single[0] || null;
            const second = c.model.single[1] || null;
            const third = c.model.single[2] || null;
            c.model.singleTop = [second, first, third];
  
        } catch (error) {
            c.model.single = []
            c.model.singleTop = []
            console.log('Error fetching leaderboard faction:', error);
        }
          
      },
      async getTeam() {
        const c = this;
    
        try {
            const response = await userService.getSeasonTeam();
            c.model.teams = response.data;
    
            c.model.teams = c.model.teams.filter(team => 
                team.members && team.members.length > 0 && 
                team.members.every(memberArray => memberArray && memberArray.length > 0)
            );
    
            const memberPromises = [];
    
            c.model.teams.forEach((team) => {
                team.members.forEach((memberArray, memberIndex) => {
                    const member = memberArray[0];
                    const promise = new Promise((resolve) => {
                        c.getCurrentTwitchInfo(member, member.twitchId, function(user) {
                            if (user) {
                                team.members[memberIndex] = {
                                    ...member,
                                    twitchDisplayName: user.twitchDisplayName,
                                    twitchProfileImage: user.twitchProfileImage
                                };
                            }
                            resolve(); 
                        });
                    });
                    memberPromises.push(promise);
                });
            });
    
            await Promise.all(memberPromises);
    
            const first = c.model.teams[0] || null;
            const second = c.model.teams[1] || null;
            const third = c.model.teams[2] || null;
            c.model.topTeams = [second, first, third];
            c.model.teamLoaded = true;
        } catch (error) {
            console.error("Error fetching team leaderboard:", error);
        }
    
      },
      getSeasons(){
        const c = this;

        seasonService.getAllSeason()
        .then(function(response){
  
          c.model.seasons = response.data;
          const sortedSeasons = response.data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
  
          const latestSeason = sortedSeasons[0];
          c.model.selectedSeason = latestSeason;
          c.get();
          c.getTeam();
        })
        .catch(function(error){

        })


 
      },
      getCurrentTwitchInfo( udata, data, callback) {
        const c = this;
        return new Promise((resolve) => {
          twitchAPI.getUsersById([{ twitchId: data }], function(userData) {
            if (userData && userData.length > 0) {
              let user = {
                twitchId: userData[0].id,
                twitchDisplayName: userData[0].display_name,
                twitchProfileImage: userData[0].profile_image_url
              };
              callback(user); 
              resolve(user);
            } else {
            
              const defaultUser  = {
                  twitchId: udata.twitchId, 
                  twitchDisplayName: udata.twitchDisplayName,
                  twitchProfileImage: udata.twitchProfileImage 
              };
              console.log(defaultUser)
              callback(defaultUser); 
              resolve(defaultUser); 
            }
          });
        });
      },
      selectedOption(){
        const c = this;
        const data = c.model.selectedSeason;
        c.model.isLoggedIn = false
        c.model.topTeams = [];
        c.model.teams = [];
        seasonService.setSeason(data)
        .then(function(response){
          c.get();
          c.getTeam();
        })
        .catch(function(error){
          console.log(error)
        })

      },
      async getSelectedOption(){
        const c = this;
        c.model.isLoggedIn = false
        if(c.model.selectedOption === '2v2'){
          c.model.memberCount = 2;
        }
        else if(c.model.selectedOption === '3v3'){
          c.model.memberCount = 3;
        }
        else if(c.model.selectedOption === '4v4'){
          c.model.memberCount = 4;
        }
        else{
          c.get();
          return;
        }
        
        try {
          const response = await userService.getSelectedTeamLeaderboard(c.model.selectedOption);
          c.model.teams = response.data;
        
          // Filter out teams with null or empty members
          c.model.teams = c.model.teams.filter(team => 
            team.members && team.members.length > 0 && 
            team.members.every(memberArray => memberArray && memberArray.length > 0)
          );
  
          // Create an array of promises for fetching Twitch user info
          const memberPromises = [];
  
          c.model.teams.forEach((team) => {
              team.members.forEach((memberArray, memberIndex) => {
                  const member = memberArray[0];
                  const promise = new Promise((resolve) => {
                      c.getCurrentTwitchInfo(member, member.twitchId, function(user) {
                          if (user) {
                              team.members[memberIndex] = {
                                  ...member,
                                  twitchDisplayName: user.twitchDisplayName,
                                  twitchProfileImage: user.twitchProfileImage
                              };
                          }
                          resolve(); 
                      });
                  });
                  memberPromises.push(promise);
              });
          });
  
          await Promise.all(memberPromises);
  
          const first = c.model.teams[0] || null;
          const second = c.model.teams[1] || null;
          const third = c.model.teams[2] || null;
          c.model.topTeams = [second, first, third];
          c.model.isLoggedIn = true;
        } catch (error) {
            console.error("Error fetching team leaderboard:", error);
        }

      }
  
    
    
    }
  });
